export const formatRoleName = (name: string) => {
  return name
    .replace(/[_-]/g, " ") // Replace _ and - with space
    .replace(
      /\w\S*/g,
      (w) => w.charAt(0)?.toUpperCase() + w?.slice(1)?.toLowerCase()
    ); // Capitalize each word
};

export function formatTimeTo12Hour(time24: string): string {
  if (!time24 || time24 === "x") return ""; // or return "N/A"
  const [hour, minute] = time24.split(":").map(Number);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
}
